import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { Base64UrlService } from './base64url.service';

@Injectable({ providedIn: 'root' })
export class CsvService {
    constructor(private dataTask: DataTaskService, private base64: Base64UrlService) {}

    public async importFileCsv(content: string): Promise<ErrorMessageResponse> {
        // Preserve the legacy UTF-8 Base64url contract, including omitted padding.
        const params: ImportCsvParams = {
            filecontent: this.base64.urlEncode(content).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''),
        };
        const response: ErrorMessageResponse[] = await this.dataTask.Post(1524, params);
        if (!response[0]) throw new Error('The CSV import returned no result.');
        return response[0];
    }
}

export interface ImportCsvParams {
    filecontent: string;
}
